import { createFileRoute } from '@tanstack/react-router'

import DetaiPenyuluhProvinsiPage from '@/components/pages/backoffice/_klb-penyuluh/_provinsi/_$provinsiId/containers/DetailPenyuluhProvinsiPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/provinsi/$provinsiId/'
)({
  component: DetaiPenyuluhProvinsiPage
})
